// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { Point } from "../../Commons/Geometry.js";
import { ChartMath } from "../Utils/ChartMath.js";
import { ToolView } from "./ToolView.js";

export let RectangleToolView = function (tool)
{
    ToolView.call(this, tool);
    this.points_ = new Array(4);
    for (var i = 0; i < this.points_.length; i++)
        this.points_[i] = new Point();
};

RectangleToolView.prototype = Object.create(ToolView.prototype);

RectangleToolView.prototype.Draw = function (gr, ww, param)
{
    var points = this.points_;
    var scrPoints = this.screenPoints;
    var scrP0 = scrPoints[0];
    var scrP1 = scrPoints[1];

    points[0] = new Point(scrP0[0], scrP0[1]);
    points[1] = new Point(scrP0[0], scrP1[1]);
    points[2] = new Point(scrP1[0], scrP1[1]);
    points[3] = new Point(scrP1[0], scrP0[1]);

    var cacheTool = this.dataCacheTool;
    if (cacheTool.fill)
        gr.FillPolygon(cacheTool.FillBrush, points);

    gr.DrawPolygon(cacheTool.Pen, points);

    ToolView.prototype.Draw.call(this, gr, ww, param);
};

RectangleToolView.prototype.DrawSelection = function (gr, ww)
{
    gr.DrawPolygon(this.dataCacheTool.PenHighlight, this.points_);

    var scrPoints = this.screenPoints;
    var scrP0 = scrPoints[0];
    var scrP1 = scrPoints[1];

    ToolView.prototype.DrawSelectedPoint.call(this, gr, ww, scrP0[0], scrP0[1]);
    ToolView.prototype.DrawSelectedPoint.call(this, gr, ww, scrP1[0], scrP1[1]);
};

RectangleToolView.prototype.IsSelectCheck = function (x, y)
{
    var points_ = this.points_;
    var points_len = points_.length;
    var TOOL_DX = ToolView.TOOL_DX;

    for (var i = 0; i < points_len; i++)
    {
        var sec = i + 1 < points_len ? i + 1 : 0;

        if (ChartMath.CalcDistanceSqrFromPointToSection([points_[i].X, points_[i].Y], [points_[sec].X, points_[sec].Y], x, y) <= TOOL_DX)
            return true;
    }
    return false;
};